import useAppContext from "@hooks/useAppContext";
import Head from "next/head";

interface ICSSLoader {
  calendar?: boolean;
  multiRange?: boolean;
  slider?: boolean;
  header?: boolean;
  all?: boolean;
}

const CSSLoader = ({
  calendar,
  multiRange,
  slider,
  header,
}: ICSSLoader): JSX.Element => {
  const { isMobile } = useAppContext();
  if (calendar || multiRange || slider || header) {
    return (
      <Head>
        {header && !isMobile && (
          <link key="header_css" rel="stylesheet" href="/styles/header.css" />
        )}
        {calendar && (
          <link
            key="calendar_css"
            rel="stylesheet"
            href="/styles/calendar.css"
          />
        )}
        {multiRange && (
          <link
            key="multi_range_slider_css"
            rel="stylesheet"
            href="/styles/multi-range-slider.css"
          />
        )}
        {slider && (
          <link key="slider_css" rel="stylesheet" href="/styles/slider.css" />
        )}
      </Head>
    );
  } else return <></>;
};

export default CSSLoader;
